import brandAssortments from '@/assortments'
import type { Assortments, Store } from '@/types'

interface FilterStoresByAssortmentProps {
  assortments: Assortments // usually the assortments of a single Store
  filters: string[] // usually the current selected filter[s]
  stores: Store[] | undefined // all the stores
}

const FilterStoresByAssortment = ({
  assortments,
  filters,
  stores,
}: FilterStoresByAssortmentProps) => {
  if (filters.length <= 0) {
    return stores
  }

  const isFilterAvailableInAssortment = filters.every((filter) =>
    brandAssortments[import.meta.env.PUBLIC_APP_BRAND].some(
      (brandAssortment) =>
        brandAssortment.toLowerCase() === filter.toLowerCase(),
    ),
  )

  if (!isFilterAvailableInAssortment) {
    return stores
  }

  return filters.every((filter) =>
    assortments.translation.some((assortment) => assortment.index === filter),
  )
}
export default FilterStoresByAssortment
